import React from "react";
import { useState } from "react";

import { HfInference } from "@huggingface/inference";

import { Input, Button } from "@material-tailwind/react";
import Alert from "@mui/material/Alert";

import CircularProgress from "@mui/material/CircularProgress";
import Icon from "./cam2.svg";
import Chat from "./chat.svg";
import Full from "./show.svg";

import Typewriter from "typewriter-effect";

import pdfToText from "react-pdftotext";

import DefaultBck from "./default.jpg";

const HUGGINFACE_API_KEY = process.env.REACT_APP_HUGGINGFACEKEY;

const inference = new HfInference(HUGGINFACE_API_KEY);

function App() {
  const [prompt, setPrompt] = useState("");
  const [image, setImage] = useState(DefaultBck);
  const [loading, setLoading] = useState(false);
  const [chat, setChat] = useState("");
  const [chatVisible, setChatVisible] = useState("hidden");
  const [chatstate, setChatState] = useState(true);
  const [busy, setBusy] = useState(false);
  const [context, setContext] = useState("");
  const [response, setResponse] = useState();
  const [audio, setAudio] = useState();
  const [info, setInfo] = useState("");
  const [visible, setVisilbe] = useState("hidden");
  const [fullscreen, setFullscreen] = useState("visible");
  const [fullscreenState, setFullscreenState] = useState(true);

  const handleChange = (e) => {
    const val = e.currentTarget.value;

    setPrompt(val);
  };

  const handleSetPrompt = (event) => {
    setLoading(true);
    if (prompt !== "") {
      console.log("not empty");

      const genImageBlob = inference
        .textToImage({
          inputs: `award winning high resolution photo of ${prompt}`,
          model: "stabilityai/stable-diffusion-xl-base-1.0",
          parameters: {
            negative_prompt: "blurry",
          },
        })
        .then((blob) => {
          const ImageGen = URL.createObjectURL(blob);
          setImage(ImageGen);
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    } else {
      console.log("empty");
      setLoading(false);
      setVisilbe("visible");
      setInfo("enter a valid prompt");
    }
  };

  const toggleChat = (e) => {
    setChatState(!chatstate);
    if (chatstate) {
      setChatVisible("visible");
    } else {
      setChatVisible("hidden");
    }
  };

  const sendChat = (e) => {
    if (e.key === "Enter") {
      if (chat !== "" && context !== "") {
        setBusy(true);
        const myText = inference
          .questionAnswering({
            accessToken: HUGGINFACE_API_KEY,
            model:
              "google-bert/bert-large-uncased-whole-word-masking-finetuned-squad",
            inputs: {
              question: chat,
              context: context,
            },
          })
          .then((res) => {
            console.log(res);
            setBusy(false);

            setResponse(res.answer + " " + Math.round(res.score * 100) + "%");

            const ans = inference
              .textToSpeech({
                model: "espnet/kan-bayashi_ljspeech_vits",
                inputs: res.answer,
              })
              .then((res) => {
                const wave = URL.createObjectURL(res);
                setAudio(wave);
                console.log(wave);
              });
          })
          .catch((err) => {
            setBusy(false);
          });
      } else {
        setVisilbe("visible");
        setInfo("ask a question and upload the reference pdf");
      }
    }
  };

  function extractText(event) {
    const file = event.target.files[0];
    pdfToText(file)
      .then((text) => {
        console.log(text);
        setContext(text);
      })
      .catch((error) => console.error("Failed to extract text from pdf"));
  }

  const summerize = () => {
    console.log("summery here..");
    inference
      .summarization({
        model: "facebook/bart-large-cnn",
        inputs: context,
        parameters: {
          max_length: 200,
        },
      })
      .then((res) => {
        setResponse(res.summary_text);
        console.log(res.summary_text);
      });
  };

  const upScaleImage = async () => {
    await inference.imageToImage({
      model: "briaai/RMBG-1.4",
    });
  };

  const toggleShow = () => {
    setFullscreenState(!fullscreenState);

    fullscreenState ? setFullscreen("visible") : setFullscreen("hidden");
  };

  async function query(data) {
    const response = await fetch(
      "https://api-inference.huggingface.co/models/google/gemma-7b",
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_HUGGINGFACEKEY}`,
        },
        method: "POST",
        body: JSON.stringify(data),
      }
    );
    const result = await response.json();
    return result;
  }
  const convo = () => {
    query({
      inputs: "how are you",
    })
      .then((response) => {
        console.log(response);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <div className="main_container   flex flex-col items-center justify-center  w-[100%] h-[100dvh]  bg-[#282c34] text-white">
      <img className="absolute object-cover w-full h-full" src={image} alt="" />
      <img
        className="animate-pulse absolute bottom-2 left-2 cursor-pointer z-50"
        src={Full}
        onClick={toggleShow}
        width={20}
        alt=""
      />

      <div
        style={{ visibility: fullscreen }}
        className="content    w-full h-full md:w-[80%] md:h-[98%] relative gap-[1%] flex flex-col items-center shadow-2xl  justify-center  bg-[#020806bc] rounded-2xl"
      >
        <Alert
          style={{ visibility: visible }}
          onClose={() => {
            setVisilbe("hidden");
          }}
          severity="info"
          className="top-0 sm:top-5 w-full sm:w-fit shadow-lg rounded-none flex justify-center absolute z-50"
        >
          {info}
        </Alert>

        <div className="flex scale-60 md:scale-90    top-5  justify-center items-center">
          <div className="">
            <img src={Icon} alt="logo" className="" />
          </div>
          <div className="logo  " style={{ fontFamily: "Julius Sans One" }}>
            Image Generator
          </div>
        </div>

        <div className="w-[80%] sm:w-[40%] flex items-center ">
          <Input
            onChange={handleChange}
            name="prompt"
            color="white"
            placeholder="input your prompt "
          />
        </div>

        <Button
          loading={loading}
          type="submit"
          onClick={handleSetPrompt}
          className="w-[80%] sm:w-[40%]"
          color="teal"
        >
          Generate
        </Button>
        <div className="ImagePlaceHolder  bg-blue-gray-800 flex items-center justify-center w-[80%] sm:w-[40%] sm:h-[60%] p-0.5  rounded-3xl">
          <img
            src={image}
            alt=""
            className="object-cover  border-1   h-full w-full   rounded-3xl shadow-lg"
          />
          <div className="text-[60%] hidden">image of: {prompt}</div>
        </div>
        <p className="text-[60%] hidden  absolute bottom-1">
          &copy; syncronia systems
        </p>

        <div className="absolute  hidden lg:visible lg:flex flex-col items-start justify-end  left-2 bottom-2  w-[20%] h-[66%]">
          <div
            style={{ visibility: chatVisible }}
            className="chatbot  shadow-lg p-2 rounded-2xl h-[70%] w-[90%]  bg-[#0615107a] flex flex-col gap-2 items-center "
          >
            <audio className="w-[80%]" autoPlay={true} src={audio}></audio>
            <input
              class="block w-full  mb-2  text-white text-xs  border border-gray-300 rounded-md cursor-pointer bg-[#80808044] dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
              id="small_size"
              type="file"
              accept="application/pdf"
              onChange={extractText}
            />
            {busy && <CircularProgress />}
            <div className="responseBox rounded-xl text-sm text-justify bg-[#00000067] w-full h-[60%]  overflow-auto scrollbar-thin scrollbar-thumb-red-300  p-5">
              <p className="animate-bounce">{}</p>
              <Typewriter
                options={{
                  strings: [response],
                  autoStart: true,
                  loop: false,
                  delay: 10,
                }}
              />
            </div>

            <Input
              onChange={(e) => setChat(e.target.value)}
              onKeyDown={sendChat}
              placeholder="chat with me"
              color="white"
              className="w-full absolute "
            />

            <div className="flex gap-1">
              <Button onClick={summerize} color="blue-gray">
                sumerize
              </Button>
              <Button onClick={convo} color="deep-orange">
                Ask
              </Button>
            </div>
          </div>

          <img
            src={Chat}
            width={30}
            color=""
            alt="logo"
            className="animate-pulse cursor-pointer "
            onClick={toggleChat}
            style={{ visibility: fullscreen }}
          />
        </div>
      </div>
    </div>
  );
}
export default App;
